// prettier-ignore
export default "@"